<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Headers from "./table_headers";
import axios from "@/axios";
import ExportButton from "@/components/export-button";
import CreateZipButton from "@/components/create-zip-button";
import {
  getDateWithFormat,
  formatCurrency,
  thousandSeparator,
  b64toBlob,
} from "@/utils";
import DPConfig from "../../../components/dataPickerConf";
import Filter from "../../../components/filters/Filter";

export default {
  page: {
    title: "Infracciones",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    "export-button": ExportButton,
    filters: Filter,
    zip: CreateZipButton,
  },
  data() {
    return {
      sortBy: "fechaInfraccion",
      sortDesc: true,
      lang: {
        formatLocale: DPConfig.formatLocale,
      },
      tableData: [],
      currentPage: 1,
      perPage: 10,
      totRegistros: 1,
      fields: [],
      multas: [],
      pagos: [],
      disable: true,
      fechaDesde: "",
      fechaHasta: "",
      filtros: ["rut", "period", "patent"],
      filtersValue: {
        rutEmpresa: "",
        period: "",
        patent: "",
      },
      isBusy: false,
      loading: false,
      inputPatente: "",
      inputRUT: "",
      buttonClicked: undefined,
      buttonClicked2: undefined,
      whereAmI: "",
      dataExport: []
    };
  },
  mounted() {
    if (window.location.pathname === "/infraccionesLOP") {
      this.fields = Headers.LOP;
    } else {
      this.fields = Headers.RAC;
    }
  },
  methods: {
    getDate(date) {
      return getDateWithFormat(date);
    },
    getCurrency(inport) {
      return formatCurrency(inport);
    },
    getNumberWithSeparators(number) {
      return thousandSeparator(number);
    },
    getInfracciones() {
      if (this.filtersValue.rutEmpresa && this.filtersValue.period) {
        this.isBusy = true;
        let data;
        data = {
          patente: this.filtersValue.patent ? this.filtersValue.patent : "",
          rut: this.filtersValue.rutEmpresa ? this.filtersValue.rutEmpresa : "",
          fechaDesde: this.filtersValue.period[0],
          fechaHasta: this.filtersValue.period[1],
          pagina: this.currentPage,
          registros: this.perPage,
        };
        axios
          .post("/GetMultas", data)
          .then((infracciones) => {
            this.tableData = infracciones.data.datos;
            this.totRegistros = infracciones.data.totalRegistros;
            const requests = [
              this.getPDFZip("/GetPDfMultas/"),
              this.getPDFZip("/GetPDfPagoMultas/"),
              this.getToExport(data)
            ];
            this.loading = true;
            Promise.all(requests).then(([multas, pagoMultas]) => {
                this.multas = multas;
                this.pagos = pagoMultas;
                this.disable = false;
                this.loading = false;
            });
            this.isBusy = false;
          })
          .catch((error) => {
            if (error.response) {
              this.$bvToast.toast(this.$t("NoData.error.message").toString(), {
                title: this.$t("NoData.error.title").toString(),
                variant: "danger",
                solid: true,
              });
            }
            this.isBusy = false;
          });
      }
    },
    getToExport(data) {
      data.registros = this.totRegistros;
      axios
        .post("/GetMultas", data)
          .then((multas) => {
            this.dataExport = multas.data.datos;
          })
    },
    getPDFZip(url) {
      return new Promise((resolve) => {
        const requests = [];
        const pdfs = [];
        for (let i = 0; i < this.tableData.length; i++) {
          requests.push(axios.get(`${url}${this.tableData[i].idMulta}`));
        }
        Promise.allSettled(requests)
          .then((responses) => {
            for (let i = 0; i < responses.length; i++) {
              if (
                responses[i]["status"] === "fulfilled" &&
                responses[i]["value"]
              ) {
                if (responses[i]["value"].data.pdf && responses[i]["value"].data.pdf !== "") {
                  pdfs.push(responses[i]["value"].data.pdf);
                }
              }
            }
            this.loading = false;
            this.disable = false;
            resolve(pdfs);
          })
          .catch(() => {
            this.loading = false;
            this.disable = true;
            resolve([]);
          });
      });
    },
    downloadMulta(row) {
      this.buttonClicked = row.item.idMulta;
      axios
        .get(`/GetPDfMultas/${this.buttonClicked}`)
        .then((documento) => {
          if (documento.data.pdf) {
            this.downloadLogic(documento.data.pdf, "multa", row.item.idMulta);
          } else {
            this.$bvToast.toast(
              this.$t("lease.pdf.error.nonFound").toString(),
              {
                title: this.$t("lease.pdf.error.download").toString(),
                variant: "danger",
                solid: true,
              }
            );
            this.buttonClicked = undefined;
          }
        })
        .catch(() => {
          this.$bvToast.toast(this.$t("lease.pdf.error.nonFound").toString(), {
            title: this.$t("lease.pdf.error.download").toString(),
            variant: "danger",
            solid: true,
          });
          this.buttonClicked = undefined;
        });
    },
    downloadPagoMulta(row) {
      this.buttonClicked2 = row.item.idMulta;
      axios
        .get(`/GetPDfPagoMultas/${this.buttonClicked2}`)
        .then((documento) => {
          if (documento.data.pdf) {
            this.downloadLogic(
              documento.data.pdf,
              "pago_multa",
              row.item.idMulta
            );
          } else {
            this.$bvToast.toast(
              this.$t("lease.pdf.error.nonFound").toString(),
              {
                title: this.$t("lease.pdf.error.download").toString(),
                variant: "danger",
                solid: true,
              }
            );
            this.buttonClicked2 = undefined;
          }
        })
        .catch(() => {
          this.$bvToast.toast(this.$t("lease.pdf.error.nonFound").toString(), {
            title: this.$t("lease.pdf.error.download").toString(),
            variant: "danger",
            solid: true,
          });
          this.buttonClicked2 = undefined;
        });
    },
    downloadLogic(pdf, name, number) {
      const blob = b64toBlob(pdf, "application/pdf");
      let fileURL = window.URL.createObjectURL(blob);
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", `${name}_${number}.pdf`);
      document.body.appendChild(fileLink);
      fileLink.click();
      this.buttonClicked2 = undefined;
      this.buttonClicked = undefined;
    },
    detailView(id, confRoute) {
      this.$store.dispatch("hideValue/updatePatente", id);
      this.$router.push(confRoute);
    },
  },
  watch: {
    currentPage() {
      this.multas = [];
      this.pagos = [];
      this.getInfracciones();
    },
    $route(to) {
      if (to.name === "infRAC") {
        this.whereAmI = "infRAC";
        this.fields = Headers.RAC;
      } else {
        this.whereAmI = "infLOP";
        this.fields = Headers.LOP;
      }
    },
  },
};
</script>
<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center" class="title">
              <h4 class="card-tittle custom-title">INFRACCIONES DE TRÁNSITO</h4>
              <div class="justify-content-end">
                <export-button :data="dataExport" fileName="Infracciones" />
                <zip
                  v-if="tableData.length > 0"
                  class="spacingButton"
                  :loading="loading"
                  :disabled="disable"
                  :data="multas"
                  :title="'Descargar Zip Multas'"
                ></zip>
                <zip
                  v-if="tableData.length > 0"
                  class="spacingButton"
                  :loading="loading"
                  :disabled="disable"
                  :data="pagos"
                  :title="'Descargar Zip Pagos'"
                ></zip>
              </div>
            </b-row>
            <filters v-model="filtersValue" @change="getInfracciones" patentView="getPatentsMultasByRut"/>
            <!-- Inicio Tabla -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :current-page="currentPage"
                :busy="isBusy"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                show-empty
              >
                <!-- Inicio Spinner en estado "ocupado" de la tabla -->
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <!-- Fin Spinner en estado "ocupado" de la tabla -->

                <template #cell(idDocumentoMulta)="row">
                  <div class="text-center" :id="`multas-${row.item.idMulta}`">
                    <b-button variant="danger" @click="downloadMulta(row)" :disabled="!row.item.idMulta">
                      <i
                        v-if="buttonClicked !== row.item.idMulta"
                        class="bx bx-download font-size-16 align-middle"
                      />
                      <b-spinner v-else small class="align-middle"></b-spinner>
                    </b-button>
                    <b-tooltip :target="`multas-${row.item.idMulta}`" triggers="hover" placement="rigth" v-if="!row.item.idMulta">
                      No existen documentos disponibles
                    </b-tooltip>
                  </div>
                </template>
                <template #cell(idDocumentoPago)="row">
                  <div class="text-center" :id="`pago-multas-${row.item.idMulta}`">
                    <b-button variant="danger" @click="downloadPagoMulta(row)" :disabled="!row.item.idMulta">
                      <i
                      v-if="buttonClicked2 !== row.item.idMulta"
                      class="bx bx-download font-size-16 align-middle"
                      />
                      <b-spinner v-else small class="align-middle"></b-spinner>
                    </b-button>
                    <b-tooltip :target="`pago-multas-${row.item.idMulta}`" triggers="hover" placement="rigth" v-if="!row.item.idMulta">
                      No existen documentos disponibles
                    </b-tooltip>
                  </div>
                </template>
                <template #cell(valor)="row">
                  {{ "$" + getCurrency(row.value) }}
                </template>
                <template #cell(fechaInfraccion)="row">
                  {{ getDate(row.value) }}
                </template>
                <template #cell(fechaPago)="row">
                  {{ getDate(row.value) }}
                </template>
                <template #cell(fechaRecepcion)="row">
                  {{ getDate(row.value) }}
                </template>
                <template #cell(patente)="row">
                  <a
                    class="links"
                    @click="detailView(row.item.patente.trim(), 'documentos')"
                  >
                    {{ row.value }}
                  </a>
                </template>
                <template #cell(contrato)="row">
                  <router-link
                    :to="{ name: 'detalleContrato', params: { id: row.value } }"
                    target="_blank"
                  >
                    {{ row.value }}
                  </router-link>
                </template>
                <template>
                  <h5 style="text-align: center">
                    {{ $t("request.table.empty") }}
                  </h5>
                </template>
              </b-table>
            </div>
            <!-- Fin Tabla -->

            <!-- Inicio Paginación -->
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    class="portal"
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totRegistros"
                  >
                  </b-pagination>
                </ul>
              </div>
            </div>
            <!-- Fin Paginación -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.custom-title {
  margin: 0 !important;
  font-weight: bold;
}
.title {
  padding: 15px;
}
.spacingButton {
  margin-left: 1rem;
}
</style>
